import { render, staticRenderFns } from "./CollapsableInfo.vue?vue&type=template&id=068e71a7&scoped=true&lang=html&"
import script from "./CollapsableInfo.vue?vue&type=script&lang=js&"
export * from "./CollapsableInfo.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableInfo.vue?vue&type=style&index=0&id=068e71a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e71a7",
  null
  
)

export default component.exports